<template>
  <div class="office-invoices-new">
    <div v-if="dataUser.is_subsidiary_br" class="navigation-options">
      <div :class="{'active': activePage == 1}" @click="activePage = 1">
        <p>Invoices</p>
      </div>
      <div :class="{'active': activePage == 2}" @click="activePage = 2">
        <p>{{ t.data_to_nfse }}</p>
      </div>
      <div :class="{'active': activePage == 3}" @click="activePage = 3">
        <p>{{translations.billing.billing}}</p>
      </div>
    </div>
    <div v-else-if="moreData.fatherIsBuilderall" class="navigation-options">
      <div :class="{'active': activePage == 1}" @click="activePage = 1">
        <p>Invoices</p>
      </div>
      <div :class="{'active': activePage == 3}" @click="activePage = 3">
         <p>{{translations.billing.billing}}</p>
      </div>
    </div>
    <div v-if="invoiceData.length < 1">
      <p class="not-found-p" v-text="t.ad_payments_nenhum_fatura_encontrada_msg"></p>
    </div>
    <div v-else-if="activePage == 1" :class="['invoices',i.open_accordion ? 'invoice-opened' : '']" v-for="(i,y) in invoiceData" :key="y">
      <div class="header-accordion">
        <div class="title-domain-plan">
          <p class="invoice-id" v-text="'#'+i.id"></p>
          <p class="invoice-info" v-if="i.titulo==='Payment of domain'">{{ i.descricao.replace('Payment of domain ', '') }}</p>
          <p class="invoice-info" v-if="i.plano"><strong>{{ t.ad_config_ad_plan }}</strong>: {{ i.plano }}</p>
          <button v-if="moreData.fatherIsBuilderall && i.payment_information" @click="paymentMethod(i.payment_information)" class="button-informations button-gray">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-coin" viewBox="0 0 16 16">
              <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/>
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
            </svg>
            {{t.payment_method}}
          </button>
        </div>
        <div class="badge-open-collapse">
          <span v-if="i.fee">{{ i.fee }}</span>
          <span v-if="i.fee"       :style="getBadgeColor('default')" class="label-status">{{ t.label_fee }}</span>
          <span v-if="i.franchise" :style="getBadgeColor('warning')" class="label-status">2 Tier</span>
          <span v-if="i.recorrente && !i.recorrente_ativo && i.payment_status != 'Pending'" :style="getBadgeColor('canceled')" class="label-status">{{ i.payment_status }} {{ t.label_cancelado }}</span>
          <span v-if="i.payment_status == 'Pending'"            :style="getBadgeColor('pending')"            class="label-status">{{ t.label_pending }}</span>
          <span v-if="i.recorrente"                             :style="getBadgeColor('recorrente')"         class="label-status">{{ t.label_recorrente }}</span>
          <span v-if="i.titulo==='Payment of extra connection'" :style="getBadgeColor('extraConnection')"    class="label-status">{{ t.extra_connection }}</span>
          <span v-if="i.titulo==='Payment of extra storage'"    :style="getBadgeColor('extraStorage')"       class="label-status">{{ t.extra_storage }}</span>
          <span v-if="i.titulo==='Payment of domain'"           :style="getBadgeColor('domain')"             class="label-status">{{ t.domain_btn }}</span>
          <span v-if="i.instant_commission"                     :style="getBadgeColor('instantCommissions')" class="label-status">{{ t.instant_commissions }}</span>
          <button @click="toggleInvoice(y)" :class="['button-toggle-accordion',i.open_accordion ? 'rotate180deg' : 'rotate0deg']">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#c4c4c4" class="bi bi-chevron-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>
        </div>
      </div>
      <div v-if="i.open_accordion" class="body-accordion">
        <div class="first-informations">
          <div class="box-left-informations">
            <div class="box-first-informations">
              <div class="invoice-payment-badge" v-html="paymentArt(i)"></div>
              <p v-if="i.plano">
                {{ t.ad_config_ad_plan }}: <b v-text="i.plano"></b>
              </p>
              <p>
                {{ t.label_recorrente }}: <b v-text="i.recorrente ? t.yes : t.no"></b><span v-if="i.recorrente">{{ i.recorrente_ativo ? ', '+t.office2_autopilot_rede_label_ativo : ', '+t.office2_autopilot_rede_label_inativo }}</span>
              </p>
            </div>
            <div class="box-first-informations">
              <!-- <button class="button-informations button-blue">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                  <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                  <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                </svg>
                Print Receipt
              </button> -->
              <a :href="invoiceUrl(moreData.invoiceUrl)" class="btn btn-xs btn-info" v-if="showPayNow(i)"><span>{{ t.pay_now }}</span> </a>
              <button v-if="i.recorrente && i.recorrente_ativo" class="button-informations button-red" @click="openModal('#modalCancel',i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                <span v-if="isSupported(i.method)">{{ t.button_cancelar }}</span>
                <span v-else>{{ t.cancel_unavailable }}</span>
              </button>
            </div>
          </div>
          <div class="box-right-informations"
               v-if="i.titulo === 'Payment of domain' &&
               i.domain_renew_link != null &&
               (typeof i.domain_renew_link != undefined)"
               @click="copy(`${i.domain_renew_link}`)">
            <span>{{ t.label_renew_link }}</span>
            <input type="text" readonly v-model="i.domain_renew_link" id="js-domain-invoice">
            <div class="copy-button">
              <img v-if="!showSuccessIcon" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content-white.svg">
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="svg-success bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="table-informations">
          <p v-if="i.notificacoes.length < 1" class="not-has-notifications">{{ t.no_register }}</p>
          <table v-else>
            <thead>
              <tr>
                <th>{{ t.label_date }}</th>
                <th>{{ t.label_price }}</th>
                <th>{{ t.label_status }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(n,h) in i.notificacoes" :key="h" v-show="n.status !== 'payment_authorized'">
                <td v-text="n.date"></td>
                <td v-text="n.currency+' '+n.amount.toFixed(2)"></td>
                <td>
                  <span v-if="translations[n.status]" class="label-status" :style="getBadgeColor(n.status,true)" v-text="translations[n.status]"></span>
                  <a v-if="moreData.fatherIsBuilderall && n.nfse !== null" :style="getBadgeColor('nfse')" class="label-status cursor-pointer" :href="n.nfse" target="_blank">NFS-e</a>
                  <!-- <span v-text="$options.filters.statusText(n, translations)"></span> -->
                </td>
                <td :class="['print-receipt', moreData.fatherIsBuilderall && n.status === 'Completed' && !n.instant_commission ? '' : 'not-has-items']">
                    <button v-if="moreData.fatherIsBuilderall && n.status === 'Completed' && !n.instant_commission" @click="print(n)" class="button-informations button-gray" style="margin: 0 10px 0 0;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                      </svg>
                      {{ t.print_receipt }}
                    </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="activePage == 2" class="box-person-form">
      <div class="person-content">
        <div>
          <h3>{{ t.contact }}</h3>
          <div class="person-form">
            <div>
              <label for="razao-social">{{ t.name_razao_social }}:</label>
              <input type="text" :class="{'error': !nfseDataVariables.razao_social}" id="razao-social" :placeholder="t.name_razao_social" v-model="nfseDataVariables.razao_social">
            </div>
            <div>
              <label for="cpf-cnpj">{{ t.vat_number }}:</label>
              <input type="text" :class="{'error': !nfseDataVariables.cpf_cnpj}" id="cpf-cnpj" :placeholder="t.vat_number" v-model="nfseDataVariables.cpf_cnpj">
              <span v-if="!validateCPFCNPJ(nfseDataVariables.cpf_cnpj) && moreData.lang == 'br'" class="error-text">{{t.please_enter_valid_cpf_cnpj}}</span>
            </div>
            <div>
              <label for="contact_email">{{ t.contact_email }}:</label>
              <input type="email" id="contact_email" :placeholder="t.contact_email" v-model="nfseDataVariables.contact_email">
            </div>
            <div>
              <label for="celular">{{ t.cell_phone }}:</label>
              <input type="tel" id="celular" v-mask="'+55 (##) #####-####'" :placeholder="t.cell_phone" v-model="nfseDataVariables.celular">
            </div>
            <div>
              <label for="telefone">{{ t.phone }}:</label>
              <input type="tel" id="telefone" v-mask="'+55 (##) ####-####'" :placeholder="t.phone" v-model="nfseDataVariables.telefone">
            </div>
          </div>
        </div>
        <div>
          <h3>{{ t.address }}</h3>
          <div class="person-form">
            <div>
              <label for="cep">{{ t.funnel_domain_zip }}:</label>
              <input type="text" :class="{'error': !nfseDataVariables.cep, 'readonly': loadingNfse}" id="cep" :placeholder="t.funnel_domain_zip" v-model="nfseDataVariables.cep" :disabled="loadingNfse">
              <span v-if="!nfseDataVariables.cep" class="error-text">{{ t.cep_withought_hyphen }}</span>
            </div>
            <div class="two-inputs">
              <div class="w-80">
                <label for="endereco">{{ t.street_avenue }}:</label>
                <input type="text" :class="{'error': !nfseDataVariables.endereco, 'readonly': loadingNfse}" id="endereco" :placeholder="t.street_avenue" v-model="nfseDataVariables.endereco" :disabled="loadingNfse">
              </div>
              <div class="w-20">
                <label for="numero">{{ t.label_number }}:</label>
                <input type="number" :class="{'error': !nfseDataVariables.numero, 'readonly': loadingNfse}" id="numero" :placeholder="t.label_number" v-model="nfseDataVariables.numero" :disabled="loadingNfse">
              </div>
            </div>
            <div>
              <label for="bairro">{{ t.neighborhood }}:</label>
              <input type="text" :class="{'error': !nfseDataVariables.bairro, 'readonly': loadingNfse}" id="bairro" :placeholder="t.neighborhood" v-model="nfseDataVariables.bairro" :disabled="loadingNfse">
            </div>
            <div>
              <label for="complemento">{{ t.complement }}:</label>
              <input type="text" :class="{'readonly': loadingNfse}" id="complemento" :placeholder="t.complement" v-model="nfseDataVariables.complemento" :disabled="loadingNfse">
            </div>
            <div class="two-inputs">
              <div class="w-80">
                <label for="cidade">{{ t.city }}:</label>
                <input type="text" :class="{'error': !nfseDataVariables.cidade, 'readonly': loadingNfse}" id="cidade" :placeholder="t.city" v-model="nfseDataVariables.cidade" :disabled="loadingNfse">
                <input type="hidden" id="codigo_ibge" v-model="nfseDataVariables.codigo_ibge"/>
              </div>
              <div class="w-20">
                <label for="estado">{{ t.state }}:</label>
                <input type="text" :class="{'error': !nfseDataVariables.estado || charactersEstadoValidate, 'readonly': loadingNfse}" id="estado" :placeholder="t.uf_to_state" v-model="nfseDataVariables.estado" :disabled="loadingNfse">
              </div>
              <span v-if="charactersEstadoValidate" class="error-text">{{ t.uf_with_2_characters }}</span>
            </div>
            <div class="button-form">
              <button @click="submitNfseData()" :disabled="loadingNfse">
                <SpringSpinner v-if="loadingNfse" class="loader" :size="20" color="#FFF"/>
                <b v-else>{{ t.send }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <invoices-billing-tab :translations="translations.billing"/>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="modalCancel" v-if="invoice">
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <button type="button" class="close button-close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">{{ t.button_cancelar }}</h4>
              </div>
              <div class="modal-body" v-if="!isSupported(invoice.method)">
                  <div class="alert alert-warning" role="alert">
                      <i class="fa fa-warning fa-2x"></i> <span v-text="cancelUnavailable"></span>
                  </div>
              </div>
              <div class="modal-body" v-else-if="!invoice.recorrente_ativo">
                  <div class="alert alert-warning" role="alert">
                      <i class="fa fa-warning fa-2x"></i> <span>
                          {{ t.label_pagamento_recorrente_cancelado }}
                      </span>
                  </div>
              </div>
              <div class="modal-body" v-else>
                  <!-- Input Confirm -->
                  <div class="form-group">
                      <div class="alert alert-warning" role="alert">
                          <i class="fa fa-warning fa-2x"></i>
                          <span v-text="cancelConfirmation"></span>
                      </div>
                      <input :placeholder="t.are_you_sure" class="form-control" v-model="confirmCancel">
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn button-cancel btn-danger" :disabled="disabledButtonCancel()" @click="disabledButtonCancel() ? '' : cancel(moreData.cancelRoute)" :class="{'is-loading': loading}">
                      {{ t.cancel_recurrency }}
                  </button>
              </div>
          </div>
      </div>
  </div>
  <div class="modal fade" tabindex="-1" role="dialog" id="modalPaymentMethod">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close button-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{t.payment_method}}</h4>
        </div>
        <div class="modal-body">
          <div class="alert-infos">
            <p v-html="t.payment_method_description_1"></p>
            <p v-html="t.payment_method_description_2"></p>
            <p v-html="t.payment_method_description_3 + ' <b><i>' + t.make_payment_by_changing_the_method + '</i></b>.'"></p>
          </div>

          <!-- Payment type -->
          <div v-if="this.paymentType" class="form-group">
            <div class="box-labels">
              <span class="label-field">{{t.payment_type}}</span>
            </div>
            <input type="text" readonly class="form-control" :value="this.paymentType" />
          </div>

          <!-- Payer Email -->
          <div v-if="this.payerEmail" class="form-group">
            <div class="box-labels">
              <span class="label-field">{{t.payer_email}}</span>
            </div>
            <input type="text" readonly class="form-control" :value="this.payerEmail" />
          </div>

          <!-- Card Number -->
          <div v-if="this.cardNumber" class="form-group">
            <div class="box-labels">
              <span class="label-field">{{t.card_number}}</span>
            </div>
            <input type="text" readonly class="form-control" :value="this.cardNumber" />
          </div>

          <!-- Card Brand -->
          <div v-if="this.cardBrand" class="form-group">
            <div class="box-labels">
              <span class="label-field">{{t.card_brand}}</span>
            </div>
            <input type="text" readonly class="form-control" :value="this.cardBrand" />
          </div>
        </div>
        <div class="modal-footer">
          <a class="btn button-print btn-info" :href="this.changePaymentMethodUrl" target="_blank">
            {{t.make_payment_by_changing_the_method}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" tabindex="-1" role="dialog" id="modalReceipt">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close button-close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">{{ t.print_receipt }}</h4>
            </div>
            <div class="modal-body">
              <div class="alert-infos">
                  <p>{{ t.receipt_info1 }}</p>
                  <p>{{ t.receipt_info2 }}</p>
              </div>
              <!-- Input FullName -->
              <div class="form-group" :class="{'has-error': e.has('name')}">
                <div class="box-labels">
                  <span class="label-field">{{ t.label_nome }}</span>
                  <span class="span-required">{{ t.required }}</span>
                </div>
                <input v-model="nome" type="text" :class="['form-control',e.has('name')?'has-erros':'']" :placeholder="t.page_Abuse_form_name">
                <span class="label label-danger" v-if="e.has('name')" v-text="e.first('name')"></span>
              </div>
              <!-- Input Address -->
              <div class="form-group" :class="{'has-error': e.has('address')}">
                <div class="box-labels">
                  <span class="label-field">{{ t.label_endereco }}</span>
                  <span class="span-required">{{ t.required }}</span>
                </div>
                <input type="text" v-model="endereco" :class="['form-control',e.has('address')?'has-erros':'']" :placeholder="t.label_endereco">
                <span class="label label-danger" v-if="e.has('address')" v-text="e.first('address')"></span>
              </div>
              <!-- Input City, State -->
              <div class="form-group" :class="{'has-error': e.has('city')}">
                <div class="box-labels">
                  <span class="label-field">{{ t.label_city_state }}</span>
                  <span class="span-required">{{ t.required }}</span>
                </div>
                <input type="text" v-model="cidadeEstado" :class="['form-control',e.has('city')?'has-erros':'']" :placeholder="t.city_state">
                <span class="label label-danger" v-if="e.has('city')" v-text="e.first('city')"></span>
              </div>
              <!-- Input VAT number -->
              <div class="form-group">
                <div class="box-labels">
                  <span class="label-field">{{ translationVatNumber }}</span>
                </div>
                <input type="text" v-model="vatNumber" class="form-control" :placeholder="translationVatNumber">
              </div>
              <!-- Input Nome da Empresa VAT -->
              <div v-if="vatNumberValidate" class="form-group">
                <div class="box-labels">
                  <span class="label-field">{{ t.label_vat_company_name }}</span>
                </div>
                <input type="text" v-model="company_name" class="form-control" :placeholder="t.label_vat_company_name">
              </div>
              <!-- Input Company Adress VAT -->
              <div v-if="vatNumberValidate" class="form-group">
                <div class="box-labels">
                  <span class="label-field">{{ t.label_vat_company_address }}</span>
                </div>
                <input type="text" v-model="company_address" class="form-control" :placeholder="t.label_vat_company_address">
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn button-print btn-info" :disabled="e.any()" @click="saveAndPrintReceipt" :class="{'is-loading': loading}">
                    {{ t.print_receipt }}
                </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Query from '../../../global/js/query';
import Errors from '../../../global/js/errors';
import { SpringSpinner } from 'epic-spinners';
import validateCPFCNPJ from '../helpers/cpf-cnpj-validator';
import qs from 'qs';

export default {
    name: "office-invoices-new",
    components: {
      SpringSpinner
    },
    props: {
      invoices:{
        type: Array,
        required: true
      },
      translations:{
        type: Object,
        required: true
      },
      moreData:{
        type: Object,
        required: false,
      },
      dataUser:{
        type: Object,
        required: true
      },
      newTranslations:{
        type: Object,
        required: true
      },
      nfseData:{
        type: Object,
        required: true
      }
    },
    data() {
      return {
        nfseDataVariables: this.nfseData,
        user: this.dataUser,
        activePage: 1,
        loading: false,
        confirmCancel: '',
        query: new Query(),
        printNotification: null,
        nome: '',
        endereco: '',
        cidadeEstado: '',
        vatNumber: '',
        company_name: '',
        company_address: '',
        currency_invoice: '',
        paymentType: '',
        cardBrand: '',
        cardNumber: '',
        payerEmail: '',
        changePaymentMethodUrl: '',
        e: new Errors([]),
        invoice: null,
        showSpinner: false,
        loadingNfse: false,
        t: [],
        invoiceData: [],
        typeStatus: [
          {'status':'default',           'background': '#C4C4C4','color':'#fff'},//gray
          {'status':'warning',           'background': '#7F3EFF','color':'#fff'},//purple
          {'status':'canceled',          'background': '#FF0000','color':'#fff'},//red
          {'status':'pending',           'background': '#FEEF2F','color':'#777'},//yellow
          {'status':'recorrente',        'background': '#15b4ad','color':'#fff'},//light-green
          {'status':'extraConnection',   'background': '#F9A000','color':'#fff'},//orange
          {'status':'nfse',              'background': '#F9A000','color':'#fff'},//orange
          {'status':'extraStorage',      'background': '#F9A000','color':'#fff'},//orange
          {'status':'domain',            'background': '#FD0080','color':'#fff'},//pink
          {'status':'instantCommissions','background': '#27AE60','color':'#fff'},//green
          {'status':'refunded',          'background': '#fea930','color':'#fff'},//light-orange
          {'status':'signup',            'background': '#3a99f8','color':'#fff'},//light-blue
        ],
        showSuccessIcon: false,
        printReceiptType: 'notification',
        printNotifications: [],
        printReceiptPeriod: null,
      }
    },
    created(){
      this.invoiceData = this.invoices;
      this.t = this.newTranslations;
      this.setUserData();
    },
    methods: {
      setUserData(){
        this.nome = this.user.nome;
        this.endereco = this.user.endereco;
        this.cidadeEstado = this.user.cidade;
        this.vatNumber = this.user.vat_number;
      },
      print(notificacao) {
        this.printReceiptType = 'notification';
        this.company_address = '';
        this.company_name = '';
        this.printNotification = notificacao;
        this.currency_invoice = notificacao.currency;
        this.setUserData();
        if(!notificacao.post.my_data == false && !notificacao.post.my_data.vat_details == false)
        {
          this.company_name    = !notificacao.post.my_data.vat_details.company_name ? '' : notificacao.post.my_data.vat_details.company_name;
          this.company_address = !notificacao.post.my_data.vat_details.company_address ? '' : notificacao.post.my_data.vat_details.company_address;
        }
        this.$nextTick(() => {
          $("#modalReceipt").modal('show');
        })
      },
      paymentMethod (payment) {
        this.paymentType = payment.payment_method;
        this.cardNumber  = payment.last_four_digit;
        this.cardBrand   = payment.brand;
        this.payerEmail  = payment.payer_email;
        this.changePaymentMethodUrl = payment.change_payment_method_url;

        this.$nextTick(() => {
          $("#modalPaymentMethod").modal('show');
        })
      },
      disabledButtonCancel(){
        return !this.isSupported(this.invoice.method) || !this.invoice.recorrente_ativo || this.confirmCancel !== this.t.button_cancelar;
      },
      openModal(modal,invoice){
        this.invoice = invoice;
        $(modal).modal('show');
      },
      isSupported(tipo) {
        return ['stripe', 'paypal', 'authorize', 'builderall_gateway'].includes(tipo);
      },
      showPayNow(invoice) {
        if(!invoice.fee && !invoice.recorrente && invoice.titulo != 'Payment of domain' && !invoice.hiden_plan && !invoice.instant_commission && !invoice.plano) {
          return ['stripe', 'paypal', 'authorize', 'pagseguro'].includes(invoice.method);
        }
      },
      toggleInvoice(index){
        this.invoiceData[index]['open_accordion'] = !this.invoiceData[index]['open_accordion'];
      },
      getBadgeColor(status,oncollapse){
        let item = '';
        let nameToFind = '';
        if(oncollapse)
        {
          switch (status) {
            case 'Completed':
              // instantCommissions because he has light green
              nameToFind = 'instantCommissions';
              break;
            case 'Pending':
              // canceled because he has yellow
              nameToFind = 'pending';
              break;
            case 'Falha':
            case 'Failed':
            case 'subscr_failed':
            case 'Cancel':
            case 'Cancelado':
            case 'subscr_cancel':
                // pending because he has red
                nameToFind = 'canceled';
              break;
            case 'Refunded':
                nameToFind = 'refunded';
              break;
            case 'Aguardando Reembolso':
                //extraConnection because he has orange
                nameToFind = 'extraConnection';
              break;
            case 'Aberta':
                //recorrente because he has green
                nameToFind = 'instantCommissions';
              break;
            case 'subscr_signup':
            case 'signup':
            case 'Available':
                //recorrente because he has light blue
                nameToFind = 'signup';
              break;
            default:
                //default with gray color
                nameToFind = 'default';
              break;
          }
        }
        let searchBy = !oncollapse ? status : nameToFind;
        item = this.typeStatus.find(s => s.status == searchBy);
        return 'background-color:'+item['background']+';color:'+item['color'];
      },
      invoiceUrl(path) {
        return `${path}/${this.invoice.id}`
      },
      paymentArt(invoice) {
        let slug = 'n/a';
        if(invoice.notificacoes.length > 0)
        {
          slug = invoice.notificacoes[0].paymentSlug;
        }
        let art = `<span>${slug}</span>`;
        switch (slug) {
          case 'paypal':
            art = `<svg  viewBox="11 45 94 33" xmlns="http://www.w3.org/2000/svg"><style>.st3{fill:#369}.st4{fill:#036}</style><path class="st3" d="M94.1 55.8c-1.1-.6-2.7-.9-5-.9-1.1 0-2.2.1-3.4.3-.8.1-.9.1-1.4.3-1.1.2-1.2 1.3-1.2 1.3l-.3 1.4c-.2.9.3.9.5.8.5-.1.7-.3 1.7-.5.9-.2 1.8-.4 2.6-.4 1.1 0 2 .1 2.5.4.6.2.8.7.8 1.3v.4c0 .1-.1.2-.4.3-1.6.1-2.7.2-4.1.4-1.4.2-2.5.5-3.5 1-1.1.5-1.8 1.1-2.4 1.9-.5.8-.8 1.8-.8 2.9 0 1.1.4 2 1.1 2.6.8.7 1.7 1 2.9 1 .7 0 1.3-.1 1.7-.2.4-.1.9-.3 1.3-.5.4-.1.7-.4 1.1-.6.4-.3.7-.5 1-.7l.2.4c-.1.5.2 1 .7 1h2.5c.5-.1 1.1-.5 1.2-1l2-8.8c0-.2.1-.4.1-.7 0-.3.1-.5 0-.7.2-1.2-.3-2.1-1.4-2.7zm-4.9 10.4c-.3.2-.7.4-1.1.6-.5.2-1 .3-1.4.3-.7 0-1.2-.1-1.6-.3-.4-.2-.5-.5-.5-1 0-.6.1-1 .4-1.4.3-.3.7-.6 1.2-.8.5-.2 1.1-.3 1.8-.4.6-.1 1.9-.2 2-.2.2 0 .3-.1.2.3 0 .2-.4 1.7-.6 2.3 0 .3-.2.6-.4.6z"/><path class="st4" d="M59.2 55.1c-.6 0-1.4.5-1.7 1.1 0 0-4 6.8-4.4 7.5-.2.4-.4.1-.5 0 0-.2-1.2-7.5-1.2-7.5-.1-.6-.8-1.1-1.5-1.1h-2.5c-.6 0-1 .5-.8 1.1 0 0 1.9 10.8 2.3 13.3.2 1.4 0 1.6 0 1.6l-2.5 4.3c-.4.6-.2 1.1.4 1.1h2.9c.6 0 1.4-.5 1.7-1.1l11.1-18.7s1.1-1.6.1-1.6h-3.4M24.3 58.9c-.8.6-2 .9-3.5.9h-.7c-.6 0-1-.5-.8-1.1l.8-3.6c.1-.6.7-1.1 1.3-1.1h.9c1.1 0 1.9.2 2.4.5.5.4.8.9.8 1.7.1 1.2-.4 2.1-1.2 2.7m6-5.5c-.3-.7-.9-1.2-1.5-1.6-.7-.4-1.5-.7-2.4-.9-.9-.2-2-.2-3.3-.3h-5.8c-.6 0-1.2.5-1.3 1.1l-3.9 17c-.1.6.2 1.1.8 1.1h2.8c.6 0 1.2-.5 1.3-1.1l1-4.1c.1-.6.7-1.1 1.3-1.1h.8c3.4 0 6-.7 7.9-2.1 1.9-1.4 2.8-3.2 2.8-5.5 0-1-.1-1.9-.5-2.5"/><path class="st3" d="M74.7 59c-.8.6-2 .9-3.5.9h-.7c-.6 0-1-.5-.8-1.1l.8-3.6c.1-.6.7-1.1 1.3-1.1h.9c1.1 0 1.9.2 2.4.5.5.4.8.9.8 1.7.1 1.2-.3 2.1-1.2 2.7m6-5.6c-.3-.7-.9-1.2-1.5-1.6-.7-.4-1.5-.7-2.4-.9-.9-.2-2-.3-3.3-.3h-5.8c-.6 0-1.2.5-1.3 1.1l-3.9 17c-.1.6.2 1.1.8 1.1h2.8c.6 0 1.2-.5 1.3-1.1l.9-4.1c.1-.6.7-1.1 1.3-1.1h.8c3.4 0 6-.7 7.9-2.1 1.9-1.4 2.8-3.2 2.8-5.5.2-1 0-1.8-.4-2.5"/><path class="st4" d="M43.7 55.8c-1.1-.6-2.7-.9-5-.9-1.1 0-2.2.1-3.4.3-.8.1-.9.1-1.4.3-1.1.2-1.2 1.3-1.2 1.3l-.3 1.4c-.2.9.3.9.5.8.5-.1.7-.3 1.7-.5.9-.2 1.8-.4 2.6-.4 1.1 0 2 .1 2.5.4.6.2.8.7.8 1.3v.4c0 .1-.1.2-.4.3-1.6.1-2.7.2-4.1.4-1.4.2-2.5.5-3.5 1-1.1.5-1.8 1.1-2.4 1.9-.5.8-.8 1.8-.8 2.9 0 1.1.4 2 1.1 2.6.8.7 1.7 1 2.9 1 .7 0 1.3-.1 1.7-.2.4-.1.9-.3 1.3-.5.4-.1.7-.4 1.1-.6.4-.3.7-.5 1-.7l-.1.4c-.1.5.2 1 .7 1h2.5c.5-.1 1.1-.5 1.2-1l2-8.8c0-.2.1-.4.1-.7 0-.3.1-.5 0-.7.5-1.2-.1-2.1-1.1-2.7zm-4.9 10.4c-.3.2-.7.4-1.1.6-.5.2-1 .3-1.4.3-.7 0-1.2-.1-1.6-.3-.4-.2-.5-.5-.5-1 0-.6.1-1 .4-1.4.3-.3.7-.6 1.2-.8.5-.2 1.1-.3 1.8-.4.6-.1 1.9-.2 2-.2.2 0 .3-.1.2.3 0 .2-.4 1.7-.6 2.3 0 .3-.3.5-.4.6z"/><path class="st3" d="M103.7 50.8h-2.5c-.6 0-1.1.4-1.3 1v.1s-.1.2-.1.6L96.3 68c-.1.4-.1.6-.2.7-.1.5.2 1 .7 1h2.6c.6 0 1.1-.4 1.3-1v-.1l3.7-16.9c.3-.4-.1-.9-.7-.9zM107.5 54.2c-.1 0-.2 0-.3.1h-.3c-.3 0-.5-.1-.6-.2-.1-.1-.2-.4-.2-.7V52h-.3v-.4h.3v-.8h.5v.8h.9v.4h-.9v1.5c0 .1 0 .2.1.2 0 .1.1.1.1.1h.5c.1 0 .1 0 .2-.1v.5zM112 54.2h-.5v-1.5-.3c0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.2-.1 0-.2-.1-.3-.1-.1 0-.3 0-.4.1-.1.1-.3.1-.4.2V54h-.5v-1.5-.3c0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.2-.1 0-.2-.1-.3-.1-.1 0-.2 0-.4.1-.1.1-.2.1-.4.2v2h-.5v-2.7h.5v.3c.1-.1.3-.2.4-.3.1-.1.3-.1.5-.1s.3 0 .5.1l.3.3c.2-.2.4-.3.5-.3.2-.1.3-.1.5-.1.3 0 .5.1.7.3.1.2.2.4.2.8v2z"/></svg>`;
            break;
          case 'stripe':
            art = `<svg viewBox="50 35 370 155" xmlns="http://www.w3.org/2000/svg"><style>.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#6772e5}</style><g id="Stripe"><path class="st0" d="M414 113.4c0-25.6-12.4-45.8-36.1-45.8-23.8 0-38.2 20.2-38.2 45.6 0 30.1 17 45.3 41.4 45.3 11.9 0 20.9-2.7 27.7-6.5v-20c-6.8 3.4-14.6 5.5-24.5 5.5-9.7 0-18.3-3.4-19.4-15.2h48.9c0-1.3.2-6.5.2-8.9zm-49.4-9.5c0-11.3 6.9-16 13.2-16 6.1 0 12.6 4.7 12.6 16h-25.8zM301.1 67.6c-9.8 0-16.1 4.6-19.6 7.8l-1.3-6.2h-22v116.6l25-5.3.1-28.3c3.6 2.6 8.9 6.3 17.7 6.3 17.9 0 34.2-14.4 34.2-46.1-.1-29-16.6-44.8-34.1-44.8zm-6 68.9c-5.9 0-9.4-2.1-11.8-4.7l-.1-37.1c2.6-2.9 6.2-4.9 11.9-4.9 9.1 0 15.4 10.2 15.4 23.3 0 13.4-6.2 23.4-15.4 23.4zM223.8 61.7l25.1-5.4V36l-25.1 5.3zM223.8 69.3h25.1v87.5h-25.1zM196.9 76.7l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7 15.9-6.3 19-5.2v-23c-3.2-1.2-14.9-3.4-20.8 7.4zM146.9 47.6l-24.4 5.2-.1 80.1c0 14.8 11.1 25.7 25.9 25.7 8.2 0 14.2-1.5 17.5-3.3V135c-3.2 1.3-19 5.9-19-8.9V90.6h19V69.3h-19l.1-21.7zM79.3 94.7c0-3.9 3.2-5.4 8.5-5.4 7.6 0 17.2 2.3 24.8 6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6C67.5 67.6 54 78.2 54 95.9c0 27.6 38 23.2 38 35.1 0 4.6-4 6.1-9.6 6.1-8.3 0-18.9-3.4-27.3-8v23.8c9.3 4 18.7 5.7 27.3 5.7 20.8 0 35.1-10.3 35.1-28.2-.1-29.8-38.2-24.5-38.2-35.7z"/></g></svg>`;
            break;
          case 'authorize':
            art = `<svg viewBox="1 24 65 15" xmlns="http://www.w3.org/2000/svg"><path d="M4.3 30.6l.8 2.3H3.5l.8-2.3m.9 5.3h3.1v-.3c-.6-.1-.8-.1-1.2-1.2-.4-1.1-.9-2.5-1.4-3.8L5 28.5l-.5.2-2.3 5.8c-.4 1-.5 1.1-1.2 1.1v.3h2.5v-.3h-.3c-.5-.1-.5-.2-.4-.7.1-.5.3-1 .4-1.3h2c.2.4.4 1 .5 1.4.2.5.1.6-.3.7h-.3v.2zM11.5 32c0-.4-.1-.5-.3-.5l-.3-.1v-.3c.6 0 1.5-.1 2.1-.2v3.8c0 .5 0 .6.4.6h.4v.3c-.7.1-1.4.3-2 .4h-.3v-.7c-.2.2-.4.3-.6.4-.3.2-.6.3-1 .3-.9 0-1.4-.6-1.4-1.5V32c0-.4-.1-.5-.3-.5l-.3-.1v-.3c.5 0 1.4-.1 2-.2v3.4c0 .7.3.9.8.9.3 0 .6-.1 1-.4V32M15.6 34.2c0 .9.4 1 .6 1 .2 0 .4-.1.6-.2l.2.3-1 .5c-.1.2-.3.2-.4.2-.9 0-1.3-.4-1.3-1.4v-3.1h-.7l-.1-.1.4-.4h.4v-.7l1.2-.9.2.1V31h1.1c.1.1.1.5-.1.6h-1v2.6M19.2 31.6c.4-.4.9-.7 1.5-.7 1 0 1.6.6 1.6 1.7v2.3c0 .6.1.7.7.7v.3h-2.6v-.3c.5-.1.6-.1.6-.7v-2.1c0-.7-.4-1-.9-1-.3 0-.6.1-.9.4V35c0 .6.1.7.5.7v.3H17v-.3c.7-.1.8-.1.8-.7v-5.4c0-.7 0-.7-.7-.7v-.3c.5-.1 1.4-.2 2.1-.4v3.4M24.8 33.1c0-1.2.5-1.8.9-1.8.7 0 1.1.9 1.1 2.4 0 1.6-.5 1.9-.9 1.9-.7 0-1.1-1.1-1.1-2.5m1.1-2.3c-1.3 0-2.6.9-2.6 2.7 0 1.2.9 2.5 2.6 2.5 1.3 0 2.6-.9 2.6-2.7-.1-1.3-1.1-2.5-2.6-2.5zM30.8 34.8c0 .6.1.7.9.7v.3h-3v-.3c.7-.1.8-.1.8-.7v-2.5c0-.7 0-.7-.7-.8v-.3c.7-.1 1.4-.2 2.1-.4V32c.1-.2.3-.5.5-.7.2-.2.5-.4.7-.4.4 0 .8.3.8.7 0 .4-.2.7-.5.8-.1.1-.3 0-.3 0-.2-.2-.4-.2-.6-.2-.2 0-.4.1-.6.6v2M33.7 32.3c0-.7 0-.7-.7-.8v-.3c.7-.1 1.4-.2 2.1-.4v3.9c0 .6.1.7.8.8v.3H33v-.3c.7-.1.8-.1.8-.8v-2.4m1.3-3.2c0 .5-.4.8-.8.8s-.8-.4-.8-.8.4-.8.8-.8.8.3.8.8zM40.3 31l.1.2-2.6 4.3h.9c.8 0 1.1-.1 1.4-.8l.2-.3.4.1c-.2.6-.3 1-.5 1.4h-4l-.2-.2 2.7-4.3h-.8c-.7 0-.9.2-1.2.7l-.2.3-.4-.2c.1-.4.3-1.1.4-1.6h.2c.1.2.2.2.6.2h3M42 32.7c.1-.8.5-1.3.9-1.3s.8.6.8 1c0 .2 0 .3-.2.3H42m2.8 1.9c-.5.3-.8.4-1.2.4-.9 0-1.6-.6-1.6-1.8 1.1 0 2.6-.1 2.8-.2.2 0 .3-.1.3-.5 0-.9-.8-1.7-1.7-1.7-1.4 0-2.6 1.2-2.6 2.8 0 1.3.9 2.4 2.4 2.4.4 0 1.3-.2 1.9-1.2l-.3-.2z" fill="#055D77"/><path d="M45.3 35.1c0-.5.4-.9.8-.9.5 0 .9.4.9.9s-.4.9-.9.9c-.4 0-.8-.3-.8-.9M54.2 36h-.7l-4.4-5.5v2.3c0 1.2.1 1.8.1 2.1.1.4.3.5 1.1.6v.3h-2.8v-.3c.6 0 .8-.2.9-.6.1-.3.1-1 .1-2.1v-2.2c0-.7 0-1-.2-1.3-.2-.3-.5-.3-.9-.4v-.4h1.9l4.3 5v-2c0-1.2-.1-1.8-.1-2.1-.1-.4-.3-.5-1.1-.6v-.4h2.8v.6c-.6 0-.8.2-.9.6 0 .4-.1 1-.1 2.1V36M56 32.7c.1-.8.5-1.3.9-1.3s.8.6.8 1c0 .2 0 .3-.2.3H56m2.7 1.9c-.4.3-.8.4-1.2.4-.8 0-1.6-.6-1.6-1.8 1.1 0 2.6-.1 2.8-.2.2 0 .3-.1.3-.5 0-.9-.8-1.7-1.7-1.7-1.4 0-2.6 1.2-2.6 2.8 0 1.3.9 2.4 2.4 2.4.4 0 1.3-.2 1.9-1.2l-.3-.2zM61.1 34.2c0 .9.4 1 .6 1 .2 0 .4-.1.6-.2l.2.3-1 .5c-.2.2-.3.2-.4.2-.9 0-1.3-.4-1.3-1.4v-3.1H59l-.1-.1.4-.4h.4v-.7l1.2-.9.2.1V31h1.1c.1.1.1.5-.1.6h-1v2.6M62.4 30.6c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3.1-.1.1-.2.2-.2s.2-.1.3-.1c.1 0 .2 0 .3.1.1.1.2.1.2.2.1.1.1.2.1.3 0 .1 0 .2-.1.3-.1.1-.1.2-.2.2s-.2.1-.3.1m0-.1c.1 0 .2 0 .2-.1.1 0 .1-.1.2-.2s.1-.2.1-.2c0-.1 0-.2-.1-.2 0-.1-.1-.1-.2-.2-.1 0-.2-.1-.2-.1-.1 0-.2 0-.2.1-.1 0-.1.1-.2.2 0 .1-.1.2-.1.2 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.2.1zm-.1-.2h-.1v-.7H62.5l.1.1v.2l-.1.1.1.1.1.2h-.1l-.1-.2s0-.1-.1-.1h-.1v.3zm0-.3h.2v-.1-.1h-.2v.2z" fill="#12A9CC"/></svg>`;
            break;
          case 'pagseguro':
            art = `<svg viewBox="135 75 300 72" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:#241f20}.cls-3{fill:#fa0}.cls-4{fill:#ed3921}.cls-6{fill:#f66418}</style></defs><path class="cls-1" d="M141.76 125.28c3.81-11.63 7.5-23.39 10.23-35.59 2.16 0 4.58.06 6.74.06l-.83 4.58c5.47-3.56 9-4.45 12.59-4.13 12.9 1.08 6 18.05-.83 22.12-4 2.42-9.41 3.43-16.91 2.42-.89 3.56-1.78 7.06-2.67 10.61-2.73-.06-5.53-.06-8.33-.06zm25.55-18.75c3.88-3.24 3.88-9.22 1.21-10.87s-8.71-.32-10.68 4.51-2.16 7.82-3.18 10.49c2.16-.19 8.71-.89 12.65-4.13zM204.95 115.3c-2.42 0-4.58.06-7 .06l.44-5.28c-5 4.7-13.09 7.82-16.78 3.37-5.08-6.93-.25-16 5.47-19.7 6.36-4.13 14.81-3.88 23.2-4.07a86.12 86.12 0 0 0-5.34 25.62zm-14.56-16.9c-3.37 3.24-3.37 9.22-1 10.87s7.56.32 9.28-4.51 1.84-7.82 2.8-10.49c-2 .19-7.69.89-11.06 4.13zM207.68 125.47l1.21-6.48c5.4 1.78 10.17 2.61 13.67.83 2.73-1.4 4.83-4.32 5.91-9.73-5 4.7-13.09 7.82-16.78 3.37-5.08-6.93-.25-16 5.47-19.7 6.36-4.13 14.81-3.88 23.26-4.07-2.61 7.25-2.67 18.62-6.1 26.7a16 16 0 0 1-8.58 8.58c-5.4 2.29-12.08 2.1-18.05.51zm12.84-27.07c-3.37 3.24-3.37 9.22-1 10.87s7.56.32 9.28-4.51 1.84-7.82 2.8-10.49c-2 .19-7.69.89-11.06 4.13z"/><path d="M291.07 125.47l1.21-6.48c5.4 1.78 10.17 2.61 13.67.83 2.73-1.4 4.83-4.32 5.91-9.73-5 4.7-13.09 7.82-16.78 3.37-5.08-6.93-.25-16 5.47-19.7 6.36-4.13 14.81-3.88 23.26-4.07-2.61 7.25-2.67 18.62-6.1 26.7a16 16 0 0 1-8.58 8.58c-5.34 2.29-12 2.1-18.05.51zm61.91-11c3.24-8.26 5.47-18.81 7.06-24.66h5.85l-.19 5.28c2.54-3.56 7.18-5.47 11.95-5.28l-2.22 6.67c-5.85-.76-10 3.94-12.27 11.7a54.93 54.93 0 0 0-1.4 6.48l-8.77-.19zm-23.64-24.84l7.25.19c-1.27 5.4-3.37 10.55-4.64 16-1.91 6.55 5.91 5.85 9.28 1.84 3-5.28 4.32-11.63 6.29-18h7.25c-2.73 8.45-5.15 16.84-6.29 25.3l-6.86-.38c.06-1.33.13-2.67.19-4.07-7.31 6.67-19.32 8.45-17.8-2.86 1-6 3.37-12 5.34-18zm-87.65 19.32c-.83 1.78-1.72 3.62-2.54 5.34 9.85 2.16 17.42.83 20.4-2.35 2.92-3.62 2.42-7.69-2.61-10.61-1.08-.76-4.13-2.29-4.07-4.07.13-4.07 6.29-3.11 10.11-1.91l1.27-5.53a26.82 26.82 0 0 0-8.71-.51 15.94 15.94 0 0 0-9.6 4.45 6.8 6.8 0 0 0-1.78 7c1 2.16 4 3.11 5.53 4 2.61 1.21 4.13 2.1 3.69 3.94-.38 1.53-2.22 2.8-5.59 2.22a20.86 20.86 0 0 1-6.1-2zm62.22-10.55c-3.37 3.24-3.37 9.22-1 10.87s7.56.32 9.28-4.51S314 96.94 315 94.27c-2 .19-7.69.89-11.06 4.13zm-11.57-4.51c-1.46-4.45-8.39-6.74-18.37-2.22-5.72 3-12.2 10.93-7.69 19.64 4.32 6.17 12.71 4.32 20.59 3.24.19-1.72.83-3.43 1-5.08-9.47 2.35-16.34 2.48-14.94-4.26 13.18 1.58 22.4-3.57 19.41-11.33zm-10.61.57c3.31-.32 3.69 3.18 1.72 4.51-3.56 1.53-3.94-.57-9.22 1.46 1.21-2.67 3.3-5.43 7.5-5.97zm121.4-.83c-3.75-5.34-12.78-5.66-20.21-.7s-10.36 13.35-6.61 18.69 12.78 5.66 20.21.7 10.36-13.32 6.61-18.69zm-8.07 11.7c-2.42 4.26-6.61 6.67-9.34 5.34s-3.11-5.85-.7-10.11 6.61-6.67 9.34-5.34 3.12 5.85.7 10.11z" fill="#93d629"/><path class="cls-1" d="M74 80.73a33.83 33.83 0 0 0-5.85 10 33.39 33.39 0 0 0 .57 25.36A34.25 34.25 0 0 0 100 137a32.62 32.62 0 0 0 13.35-2.8 34.44 34.44 0 0 0 10.74-7.2 34.12 34.12 0 0 0 7.75-36.23 34.65 34.65 0 0 0-5.85-10 33.18 33.18 0 0 0-8.71-7.37 32.37 32.37 0 0 0-16.72-4.77h-.89a34 34 0 0 0-17 4.77A32.2 32.2 0 0 0 74 80.73zM381.27 121.34a9.55 9.55 0 0 0-3.56.64 8.68 8.68 0 0 0-2.86 1.91 9.12 9.12 0 0 0-1.91 2.8 9 9 0 0 0-.64 3.5 8.9 8.9 0 0 0 .64 3.43 9.12 9.12 0 0 0 1.91 2.8 11 11 0 0 0 2.92 1.91 9.22 9.22 0 0 0 3.5.64 11 11 0 0 0 3.56-.64 8.68 8.68 0 0 0 2.86-1.91 7.8 7.8 0 0 0 1.91-2.86 8.9 8.9 0 0 0 .64-3.43 9 9 0 0 0-.64-3.5 7.57 7.57 0 0 0-1.91-2.8 9 9 0 0 0-2.92-1.91 10.34 10.34 0 0 0-3.5-.57zm0 5.66a2.57 2.57 0 0 1 2.1.89 3.4 3.4 0 0 1 .83 2.35 3.07 3.07 0 0 1-.83 2.29 2.64 2.64 0 0 1-2.1.83 2.59 2.59 0 0 1-2-.83 3.07 3.07 0 0 1-.83-2.29 3.13 3.13 0 0 1 .83-2.35 2.37 2.37 0 0 1 2-.89zM369.51 133.8a19.62 19.62 0 0 0 .19-3v-9.15h-6v9.22a4.81 4.81 0 0 1-.38 2.22 1.39 1.39 0 0 1-1.33.64 1.29 1.29 0 0 1-1.27-.64 4.47 4.47 0 0 1-.38-2.22v-9.22h-6v9.15a13.25 13.25 0 0 0 .19 3 5.19 5.19 0 0 0 .7 1.91 6.48 6.48 0 0 0 2.8 2.42 8.85 8.85 0 0 0 4 .89 8.09 8.09 0 0 0 4-.89 6.31 6.31 0 0 0 2.73-2.42 5.93 5.93 0 0 0 .83-1.91zM398.87 121.72h-6.03v16.85h11.88v-5.47h-5.85v-11.38z"/><path class="cls-3" d="M122.76 81a27 27 0 0 0-16.46-9.73 27.35 27.35 0 0 0-18.81 3 27.07 27.07 0 0 0-7.69 6.36A26.26 26.26 0 0 0 75 89.5a26.73 26.73 0 0 0-1 10.49 23.4 23.4 0 0 1 3.88-6.29 24.33 24.33 0 0 1 8.45-6.36A27.45 27.45 0 0 1 96.7 85a26.43 26.43 0 0 1 10.61 2.16 24.17 24.17 0 0 1 9.15 6.48 27.14 27.14 0 0 1 2.61 3.31 11 11 0 0 1 3.31.38 11.73 11.73 0 0 1 6.29 4.07l.06-1.27a27.9 27.9 0 0 0-1-10 28.3 28.3 0 0 0-5-9.09zM73.24 113.27a23.1 23.1 0 0 0 2.61 7.63 24.09 24.09 0 0 0 5.08 6.36l1.08.89A32.36 32.36 0 0 0 94 133.36a20.07 20.07 0 0 0 8.26-.25 23.28 23.28 0 0 0 8.07-3.5 11 11 0 0 1-6-3.69l-.64-.7a30.05 30.05 0 0 1-21.8-5.72 30.54 30.54 0 0 1-8.2-9.53l-.51-1.08c0 1.4 0 2.92.13 4.39z"/><path class="cls-4" d="M105.22 90.64a25.5 25.5 0 0 0-10-2 23.36 23.36 0 0 0-9.6 2.22 21.56 21.56 0 0 0-7.69 5.85 21.28 21.28 0 0 0-3.56 6.1 27.74 27.74 0 0 0 11.12 16.46 29.29 29.29 0 0 0 10.87 4.77 32.32 32.32 0 0 0 7.44.51 14.55 14.55 0 0 1-1.91-5.28 18 18 0 0 1 .13-6.1 19.78 19.78 0 0 1 2.8-7.25 23.29 23.29 0 0 1 5.48-5.92 21.08 21.08 0 0 1 4.51-2.48l-.83-.89a26.45 26.45 0 0 0-8.77-6z"/><path d="M129.18 106l-.83-1.33a29.27 29.27 0 0 1-6.1 10.87 23.28 23.28 0 0 1-8.58 13.28 12.74 12.74 0 0 0 4.58-.7 13.78 13.78 0 0 0 4.13-2.42 42.69 42.69 0 0 0 5-5.72l.25-.38a41.21 41.21 0 0 0 1.72-3.94 18.18 18.18 0 0 0 .83-3.94 13.93 13.93 0 0 0-.19-3.69 17.52 17.52 0 0 0-.76-2z" fill="#f80"/><path class="cls-6" d="M70.13 90.2a36.1 36.1 0 0 0-2 10.3 33.9 33.9 0 0 0 2.61 13.6 31.85 31.85 0 0 0 3.33 5.9 32.25 32.25 0 0 0 4.32 5 24 24 0 0 1-6.17-13.35 26.51 26.51 0 0 1-.06-5 29.23 29.23 0 0 1-1.78-9.79 32.27 32.27 0 0 1 1.53-9.34A39.06 39.06 0 0 1 75 81.43a32.2 32.2 0 0 0-4.83 8.77zM131.4 92.1a33.8 33.8 0 0 0-3.24-7.44 28.55 28.55 0 0 0-5-6.17 26.91 26.91 0 0 0-6.16-4.82 31.92 31.92 0 0 1 5.4 4.77 27.73 27.73 0 0 1 5.6 9.34 27.28 27.28 0 0 1 1.4 10.87 33.88 33.88 0 0 1-.44 3.43 15.78 15.78 0 0 1 1.27 2.54 16.81 16.81 0 0 1 .64 8.14 35.14 35.14 0 0 0 2-12.08 36.68 36.68 0 0 0-1.46-8.58z"/><path class="cls-6" d="M120.79 100.62a20.06 20.06 0 0 1 1.72 6 27.68 27.68 0 0 1 .19 6l-.38 2a25.65 25.65 0 0 0 5.53-10.68 17.18 17.18 0 0 0-2-1.78 8.46 8.46 0 0 0-5.08-1.53z"/><path class="cls-4" d="M115.45 124.27a22.73 22.73 0 0 0 2.61-4.89 30.93 30.93 0 0 1-11.82 5.28 8.53 8.53 0 0 0 2.35 2.42 9.58 9.58 0 0 0 3.05 1.4 24 24 0 0 0 3.81-4.2zM97.4 133.86l3.88.19a32 32 0 0 0 9.53-1.72 33 33 0 0 0 8.07-4 12.74 12.74 0 0 1-4.83 1.33 7.82 7.82 0 0 1-1.78.13 25.75 25.75 0 0 1-14.87 4.07z"/><path d="M118.76 107.87a23.37 23.37 0 0 0-2.54-6.55 15.92 15.92 0 0 0-5.53 3.11 21.25 21.25 0 0 0-4.51 5.53 18.39 18.39 0 0 0-1.78 6.36 13.15 13.15 0 0 0 .6 5.68 8.54 8.54 0 0 0 .83 1.72 22 22 0 0 0 6.36-1.78 23.84 23.84 0 0 0 6-3.43l.19-.13a29.87 29.87 0 0 0 .83-4 28.86 28.86 0 0 0-.44-6.55z" fill="#ffec00"/></svg>`;
            break;
          case 'jvzoo':
            art = `<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAiCAIAAAHxGbMKAAAACXBIWXMAAA7FAAAOxgFsQb88AAAOEUlEQVRYw7VZCXRTVRq+SZo0aZOmaUibdEmT5m0pZSm00qYr+4iOULAgS9laC22Tpk03UAHPKGc86AgyoFQER0Q5zIAKjIDIiKKAijugoEjLIksLbdO9SdrM//LC62vSMnLOeM/tzX13+e+9//2X779Fbre715PcnMR8Ivjr6+trt9uh8n2a0dHdxbR4+yBpxEIov/ryC4RQZzXVasNdK+ORw+HoqsTP/fBDVxreVIY7a4ieGupmKZagFCGYDtRdLhdDiknQAiViV2Yr7Cfd12ZvgdLpdDbfbmQ34u1rLsc1CLnHx3dUEs4a0v0EBduhaV4sIafhcncGGS4VtdqI6xZDUZKqp5oEyt69IMTz2Qg9j/1mEjti7549f9+0iTuB2+udBsdrqqB2GqMEMjlsLkguv2jG2yrJRivm9kveaczHbSs+NjPr2Jg4GaLTVbNBplD+dO7s6XwcelvK8ZemqFtbmhvKKeADYmnAB5DoMOEChHzukullKgzbEZe3bMlsoXdg6pcFZoRPCYQL4qLgurlz+u+TPVVHW2tbczNDbEbOzFm5ua3NTVwB6JcrZuoD6dkn83Q9GaR3S5nG1griagnG43nPDGv6cg/YNW+4wp6K0U0ICSQShQh1VZFCAR+EoqUci5JLOjx3EB1HeHkwbhgPhrqyjIcPHuzLIGpM4d8VGKB9xyPRtbW1yUrep3m6y3WXVqYqpz2SgzZu3NhWgQOxUyc+20JoJitliMdvKsPs5bjdhu/K0YJcNVixuhK8u4poseGOnm404JoRajcNIgE+aQCvL9fXD4uK9pG3wXl9XwmmhavVW199lRGd358QV/VYce9llNrl4t4ney+BCDHSx1Ux7v1zCfbzgWsA4MJXrV7zeGJY/kj5YlVIWcywnEcfZaSAFkRHDy4WZqhlRYmK5Ymhy0bLZxLSqVOmMjvjiiy7PEO535pxV+aLQ9oryZf/FJmnUYBSIc/2gVFfnjpl06rGh0kDZUqRTAHtDVa8bwWFeAFQHxGKRoXSJaRXNm+G0hiCSBkyenTZ6XAMsHHMLoQI3SrFYqV8niSoJ50oUcubGxtLSy2fJRlKIhUVlpIMbfDtMqypnAQSfS7n0oTgW1YCBQSFx+glAXyQs+0PR3+5JE4UooyI0U/USTuqyFB1jFeKGhoa0N30bb6hq5pEAtHavz5XZyIbU+lj2dOIWjJSLOCD2O6dpUWc9OVi/Xu5WsQPRDxh7bSoX4sMdcWGlaZw0Czo/WKx/ot8fP36DXAFtL3fsGEDXLL07uSjHx5hjE6KiNeQYmhJxT5PxtaufbawsBAULgghiScHebLsbiXYM7eyogIJxVJPO9OybetWr+XykWCu8CDEB/PfkBH/8IwZ/jI9qPnyoTPAkLNeyMcjcX0kt2WoYf6Gllu5P7V1ulw/njvHFwjuV9mRv7PiHtani9FZAUKsY7gHJ7kVxDUKrGnwX4w+itO5evXqN0ZjpeW2np4eruHgGgIfUzLgbriXD9Cgvb29w27vG7gSdIEIhfFQR6vd3txk53id37sMe2PAk6JEuVLEs2hCQd377nbB3sn44ddNZNk4FRie5aNDi8fQNqD3ru3xYYAv07itsEyiAt2wYDAfDI81MtTedIdZo+HGjalh0qmRoc4aqq2CaK8k6ksMpwuIHW+8cW93wvC2n2lArvnObVuyAnwWbZcyyONj4/65ezejsMiDokCZ5BHRUF9hUtUVGYrHhOl0uogAlCCnTZxWjJKSk4NDlXoJbd8gA5Pz8hbASv3LALkjhw/tm61rraBt1+VxWGumcXru7K6urte3bdsWH5OjlDp7elQRmsNz9bDGhqlRMOzfc3TgoMGIQb5SYng6U329lARwB59w4usWzKQJBHb03w3Ynoqqmjozeb2UoOITthHq3kxKKFd4j5JFiWQhUKk305MXjhpmtZhDwqMBHCaoxGBDkVj283Jsy4NRjmoCgKAKWpDQbiMeI4Ndjh7E5eOo5NS2KuOJxdjbb745MZDfmUZzb3rOzHoT+UxcBH1hVSSwdERE8IH33mWWd9JEaSJJpix7pfGJdHXvCmAGD1p4IimY41gxLUe0qTYajYzpjJEFwE6tSQqA2/DZZsIoqThZHuRKp9c7vSTuThkeKAzg8fjMeD6P11VFL4NEtLVsryCKk1XeFp5ILhYAZEE85LUCPB6vt4bsqMABqjfa6CU9uITnSCcWaBS9GeTe4dEatQaYCUgZxAwgM+TmcuzYAh1MAerd1SRU3E8YJSJhmw0HoN9dRQIIaq2Kj9EbvALN+HwGw44zpTNXNTIlFZAWICCGdQyLpBx3AFl81xcEeeqws9otW+AnxDMS1A6kzgum/GE0Iw7gis6l4I0p2IVUYnlxMYsU751YjOxDEA2K80HSr9RdWqMPd2cQUoR8jN6gFtbfgA4SOPhbaCjTMzOBA69v3+4TNQ21zP+20P5R1qA+yj8MG3TWAEvqaWlouHXhwgV2r4P6Rp+6j2Mcaoc+W0I+qNHfkN/D3vv7Gh8HxMhE9oQJIMhyhLInTmRDLX+06lP3x7hDrTUg/Pm/n4cN60B4OjvaI2N1phDJ7HC5OFTR0tTEyskfe56hbpNxTUOpJIuT/WdB5cqlS7xAcWFk2KpYFRKJf7tyxd/vcRXmj5U35iTXrl3LysoSh6oC5SooIzQa8TCVSDkMcsLIkV+dPs0GS+y2GBk7dvRDUPHNZNRLmIbGXmKZQKoQBIdCGSALE8rCANMXFi5raW72iVz+EHljInuoz5mfFyHkO54Y4VpBNZaRWkXQT8kGdzblnpQwVSrSjxjp9kN1MH3Diy/CGT4ZG7dZrylLV7mfNLbYCIi8O6ooyF1VVGcV6X4q/vnJNMA48elxmNXd3Q2l626CusOT2NciqLNdTMmmQcLgwVFur0utw3MMYthEUzl+IJcOd56JC3elE+D9XqNo+PH9N9+wl8kcZvHiJdB+yUQeGB4TKRcVjJDNpYIWJsgKx4RBMLp4VNhPhXGA1wCiAHQBb7z/3Xd279qVk/uYKWtiWvYkU/aktPGToPLQjFmbN2/q6GgHmtd/u7Zu3bpp02dmTpySNWkqU0568M9LCgrfP7CfK/OD6A+7v/M/noOdbZqiaa0gwFN7QjOUqghuSyPsJgxCPIi0nlq9GkY6AGDDffb2jk1+QCXgt2Qav0imEeZTTz7pdjnPfPs1RRLSwICd07XOGvJyiaGnmnxzulYcQCMMeQB6OycWoEJTBQW5pdLYXEHXAc7sydUF0c8nKEkdeHIJdsdmvGOj6FxBV2BYQ7lxVVYkDHjh+XV0CM++WPm8HzAuura2FoZ+lY83WvEmG5EZS0eTfD7vRKIOMIMzy5gtEeCjRrs957c3NSnCw1NCJNB+bhwNJ1atWXP0yAeIL8RChd8VYIDEAD+C1K3MoDVq3pzc4YlJY5S89ioKruvYfF3+yNBHcUkuLlmYELJzevTNUnrK7pyYlelqiKp/s2A7HolaEC+FATNxSdGYsE/zdIDLOquoktEhkjB1T1fngICUEVNGIhlpnpE7J1qIbtuMEFufLyIAu5QUFStjdWURMsBZIHIQecPO6i5evPTzz4gvKIgMc2dSFx8whAUIBEIhdM0dHnqnnIRVb1vx+hI8IxoAEvrL02tg4fpLF4E5z2SFO2rIX0pIIF5qLetzOXudjnkL8gCpXy+jOiuJteM1+3O1fSvId3JjYe6RQ+/3AqztaFNr4+DwwAt7JZWh5uMJo5m76H+esNvtn586efLEZ6Cgp06eOHhgvyBInj9SDiAXlOdfs2hyZ7/7dv7SfDWA1Ewj4NTzDxgkfP7YxERAbS8YIgAa3UjBDMGBdOA0Vtm7gqovpiHlh3NjI6QiaFy0YN6uXW+DVry2dau5uJje3zw9SOB7uToQq7d2/KPx1s2r9b8qNTE5mKSrmrppwarT1Gcfj3PVUKVJigCJ7Mw3X127cvno4YMwd+MUTXc1cclMAunSMhsjVohR4gP798GItROj98yKfXOG9q0Z2l05sWcLDXDpEG1csxrDhCh7wiQYuXfPHtp2jYkDjNqVTkxRguvnfTAqticNbzERY0IAliKtPPDXIuw3s+FWKfb5Iv0Hc3XHFuj/M1/30YK4jxdiHy80fJRn+HwJNg2Xfzw/Fph1oxTb+Uj0UyblalPYqrRh+2ZrG6w4XOnJRfpsXQhIO5CqK8bgANC7Jm3Ys9nhQBakFND2qw/RRvKz458wyANBrAw1c2lZoEBw3jy83kJetpBXSykQMFj4uQnqKA9qfuXlzYx2dba3iZWq5REhfZkUaNH+kdpvxurhrhyZlClIpKWM+/buhfFl48KBC9esFJC6AtniKT35MtTpVaibZdSZZXQLDIPPejPpWZ2C2Ou7QsKcpGTikSl66ZllxLXSflKww19LyOOLsAmxNPsO7NvHwiiv/sCp1q9fv7TgcbCAi/ML8guXV9WsAMD707kz3PdtxiHkLV0K4XVzhrE5FbudYriVYgC1mauSBcpkjTdvMtJ7+NDByuoas7UcJMFC53KLt2KzWMvp7KmbrZz2u2PKbJWwmR/Pepe++POFF17427Jic8GyouUlluXF5iKzxVZZ9fr2bQ23bvo8a/b7H8YSwI6ZEk7ItHBDfebzyOHDIO6HRuu70vCr4wzuDLIiRokEARfPn+f6IoaUf2IcJXe5oeqs8/CfwrT4PIzdNx5lqMPPhMmTwXesJ6N2xEenBNO6/u3XX/d6juGDsgf9d8gfiEcHxQc+b+nspw+hX86f//HMD53t7awjHirEG+plzecZyP9V3/9fToM+XLPlfwE4UywVlvUT9gAAAABJRU5ErkJggg==">`;
            break;
        }
        return art;
      },
      statusText(notificacao, translations) {
        let text = null;
        switch (notificacao.status) {
          case 'Falha':
          case 'Failed':
          case 'subscr_failed':
            if (notificacao.retry_at) {
              text = `${translations.textFailed} ${notificacao.retry_at}`;
            }
            break;
          case 'Cancel':
          case 'Cancelado':
          case 'subscr_cancel':
            text = translations.textCancel;
            break;
        }
        return text;
      },
      validadeUserData() {
        if (!this.nome) {
          this.e.add('name', this.translations.nameRequired)
        }
        if (!this.endereco) {
          this.e.add('address', this.translations.addressRequired)
        }
        if (!this.cidadeEstado) {
          this.e.add('city', this.translations.cityRequired)
        }
        return this.e.any();
      },
      async saveAndPrintReceipt() {
        this.validadeUserData();
        if (this.e.any()) {
          return;
        }
        let pathname = window.location.pathname.replace(/\/$/g, '');
       if (this.user.changed) {
            this.loading = true;
            let notifications = this.printReceiptType == 'notification' ? [this.printNotification.id] : this.printNotifications;
            for (let i = 0; i < notifications.length; i++)
            {
              const notification = notifications[i];
              let data = {
                'company_name': this.company_name,
                'company_address': this.company_address,
                'notification_id': notification,
                'user': {'nome': this.nome, 'endereco': this.endereco, 'cidade': this.cidadeEstado, 'vat_number': this.vatNumber}
              };
              await axios.post(`${pathname}/save-user-info`, qs.stringify(data))
                .then(({data}) => {
                  if (this.printReceiptType == 'notification') {
                    alertMsg('success', data.message);
                  }
                }).catch(({response}) => {
                  alertMsg('error', response.data.message);
                });
            }
            this.loading = false;
        }

        const receiptRoute = this.printReceiptType == 'notification'
          ? `${pathname}/print-receipt/${this.printNotification.id}`
          : `/us/office/billing/${this.printReceiptPeriod}/print-receipt`

        $("#modalReceipt").modal('hide');
        window.open(receiptRoute);

        if (this.printReceiptType == 'notification') {
          window.location.reload();
        }
      },
      cancel(url) {
        this.loading = true;
        axios.post(`${url}/${this.invoice.id}`, {}).then(() => {
          this.loading = false;
          this.invoice.recorrente_ativo = false;
          alertMsg('success', this.translations.cancelSuccessText);
          $('#modalCancel').modal('hide');
        }).catch(({response}) => {
          this.loading = false;
          alertMsg('error', response.data.message);
        });
      },
      copy(text) {
        this.showSuccessIcon = true
        setTimeout(() => {this.showSuccessIcon = false;}, 2000);

        var _input = document.createElement('input');

        document.body.appendChild(_input);

        _input.value = text.trim();
        _input.select();

        document.execCommand('copy');
        alertMsg("success", this.t.copied);
      },
      validateNsfeData(){
        let hasErrors = [];
        for (var key of Object.keys(this.nfseDataVariables)) {
          if(key == 'estado')
          {
            if(!this.nfseDataVariables[key] || this.nfseDataVariables[key].length > 2)
            {
              hasErrors.push(key);
            }
          }
          if (key == 'cpf_cnpj' && this.moreData.lang == 'br') {
              if (!this.validateCPFCNPJ(this.nfseDataVariables.cpf_cnpj)) {
                hasErrors.push(key);
                continue;
              }
          }
          else if(key == 'complemento' || key == 'celular' || key == 'telefone' || key == 'contact_email' || key == 'codigo_ibge')
          {
            continue;
          }
          else if(!this.nfseDataVariables[key])
          {
            hasErrors.push(key);
          }
        }
        return !hasErrors.length > 0;
      },
      async submitNfseData() {
        if(this.validateNsfeData())
        {
          this.loadingNfse = true;
          let pathname = window.location.pathname.replace(/\/$/g, '');
          await axios.post(`${pathname}/save-user-info`, qs.stringify(this.nfseDataVariables))
            .then(response => {
              alertMsg('success', response.data.message);
            })
            .catch(e => {
              alertMsg('error', e.data.message);
            })
            .finally(f => {
              this.loadingNfse = false;
              window.location.reload();
            });
        }
        else
        {
          alertMsg('error', this.t.link_generator_error_origin);
        }
      },
      validateCPFCNPJ (value) {
        return validateCPFCNPJ(value);
      },
      getAddressInfoByZipcode(zipcode) {
        this.loadingNfse = true;
        this.nfseDataVariables.cep = zipcode;

        let pathname = window.location.pathname.replace('/invoices', '').replace(/\/$/g, '');

        axios
          .get(`${pathname}/viacep/${zipcode}`)
          .then((response)=> {

            let data = response.data.data;
            if(response.data.success) {

              if (data) {
                this.nfseDataVariables.estado      = data.uf ? data.uf : '';
                this.nfseDataVariables.codigo_ibge = data.ibge ? data.ibge : '';
                this.nfseDataVariables.bairro      = data.bairro ? data.bairro : this.nfseDataVariables.bairro;
                this.nfseDataVariables.endereco    = data.logradouro ? data.logradouro : this.nfseDataVariables.endereco;
                this.nfseDataVariables.cidade      = data.localidade ? data.localidade : '';
                this.nfseDataVariables.complemento = data.complemento ? data.complemento : this.nfseDataVariables.complemento;
              }

              // alertMsg('success', response.data.message);
            }
            else {
              // alertMsg('error', response.data.message);
            }
          })
          .catch((error)=>{
            console.log(error);
          })
          .finally(() => {
            this.loadingNfse = false;
          });
      },
    },
    computed: {
      notifications() {
        return this.invoice.notificacoes.filter(notificacao => !['subscr_signup', 'subscr_eot'].includes(notificacao.status));
      },
      cancelUnavailable() {
        return this.translations.cancelUnavailableText.split('{gateway}').join(this.invoice.method);
      },
      cancelConfirmation() {
        return this.translations.cancelConfirmationText.split('{word}').join(this.translations.Cancelar.toLowerCase());
      },
      translationVatNumber() {
        return this.currency_invoice != 'BRL' && this.currency_invoice != '' ? this.t.cpf_vat_number : this.t.label_vat_number;
      },
      charactersEstadoValidate() {
        if(!this.nfseDataVariables.estado)
        {
          return false;
        }
        return this.nfseDataVariables.estado.length > 2;
      },
      vatNumberValidate(){
        if(!this.vatNumber)
        {
          return false;
        }
        return this.vatNumber.length > 0;
      }
    },
    filters: {
      statusClass(status) {
        let label = '';
        let style = '';

        switch (status) {
          case 'Completed':
            label = 'label-primary';
            break;
          case 'Falha':
          case 'Failed':
          case 'subscr_failed':
            label = 'label-warning';
            break;
          case 'Cancel':
          case 'Cancelado':
          case 'subscr_cancel':
            label = 'label-warning';
            break;
          case 'Aguardando Reembolso':
            label = 'label-warning';
            break;
          case 'Aberta':
          case 'Pending':
          case 'Available':
            label = 'label-success';
            break;
        }
        return label;
      },
      statusText(notificacao, translations) {
        let text = null;
        switch (notificacao.status) {
          case 'Falha':
          case 'Failed':
          case 'subscr_failed':
            if (notificacao.retry_at) {
              text = `${translations.textFailed} ${notificacao.retry_at}`;
            }
            break;
          case 'Cancel':
          case 'Cancelado':
          case 'subscr_cancel':
            text = translations.textCancel;
            break;
        }
        return text;
      },
      lowerCase(str) {
        return str.toLowerCase();
      }
    },
    watch: {
      nome: {
        handler() {
          this.user.changed = true;
          this.e.remove('name');
        }
      },
      endereco: {
        handler() {
          this.user.changed = true;
          this.e.remove('address');
        }
      },
      cidadeEstado: {
        handler() {
          this.user.changed = true;
          this.e.remove('city');
        }
      },
      vatNumber: {
        handler() {
          this.user.changed = true;
          this.e.remove('vat_number');
        }
      },
      company_address: {
        handler() {
          this.user.changed = true;
        }
      },
      company_name: {
        handler() {
          this.user.changed = true;
        }
      },
      'nfseDataVariables.cep': {
        handler(newValue) {
          newValue = newValue.replace("-", "");

          if (newValue.length >= 8 ) {
            this.getAddressInfoByZipcode (newValue);
          }
        }
      }
    },
    mounted() {
      this.printReceiptType   = 'notification';
      this.printNotifications = [];
      this.printReceiptPeriod = null;

      this.query.parse();
      // verifica query, se existe atribui
      if (this.invoiceData.length && this.query.has('invoice')) {
        this.invoice = this.invoiceData.find(inv => inv.id === this.query.get('invoice'));
      }
      // se vazio atribui primeira fatura, sem mudar query
      if (this.invoiceData.length && !this.invoice) {
        this.invoice = this.invoiceData[0];
      }

      const urlParams = new URLSearchParams(window.location.search);
      if (!!urlParams.get('period') && this.moreData.fatherIsBuilderall) {
        this.activePage = 3;
      }
    }
  }
</script>

<style scoped>
  p{
    margin: 0;
  }
  .not-found-p{
    display: flex;
    justify-content: center;
    color: #ACACAC;
  }
  .navigation-options{
    display: flex;
  }
  .navigation-options div{
    color: #B4B4B4;
    border-bottom: 2px solid #B4B4B4;
    padding: 0 1rem 1rem 1rem;
    cursor: pointer;
  }
  .navigation-options .active{
    color: #006CFF;
    border-bottom: 2px solid #006CFF;
  }
  .office-invoices-new{
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
  .invoice-opened{
    border: 1px solid #097EF6 !important;
  }
  .invoices{
    background-color: #fff;
    border: 1px solid #C4C4C4;
    padding: 1em;
    border-radius: 8px;
    color: #ACACAC;
  }
  .form-control{
    border-radius: 4px;
    border-color: #C4C4C4;
  }
  .badge-open-collapse,
  .title-domain-plan{
    display: flex;
    align-items: center;
    gap: 1em;
  }
  .badge-open-collapse{
    flex-wrap: wrap;
    justify-content: center;
  }
  .header-accordion{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 1em;
    flex-wrap: wrap;
    gap: 1em;
  }
  .body-accordion{
    margin-top: 1em;
    border-top: 1px solid #f2f2f2;
    /* animation-name: openaccordion;
    animation-duration: 1s; */
  }
  .rotate180deg{
    transform: rotate(180deg);
    /* animation-name: rotate180deg; */
    animation-duration: 1s;
  }
  .rotate0deg{
    transform: rotate(0deg);
    /* animation-name: rotate0deg; */
    animation-duration: 1s;
  }
  .invoice-id{
    margin: 0;
  }
  .button-toggle-accordion{
    background-color: transparent;
    border: none;
    outline: none;
  }
  .first-informations{
    display: flex;
    justify-content: space-between;
    padding: 1em;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em;
  }
  .not-has-notifications{
    display: flex;
    justify-content: center;
  }
  .table-informations{
    padding: 1em;
  }
  .table-informations table{
    width: 100%;
  }
  .table-informations thead{
    border-radius: 4px;
    background-color: #F2F2F2;
  }
  .table-informations th,td{
    padding: 11px 5px;
  }
  .table-informations td{
    color: #333333;
  }
  .table-informations tr{
    min-height: 55px;
    height: 2.4em;
  }
  .table-informations tr:nth-child(even){
    background-color: #f8f8f8;
  }
  .label-status{
    padding: 4px 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }
  .print-receipt{
    display: flex;
    justify-content: right;
  }
  .box-left-informations {
    display: flex;
    justify-content: space-between;
    padding: 1em;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em;
  }
  .box-right-informations {
    height: 100%;
    display: inline-flex;
    align-items: stretch;
    width: 40%;
  }
  .box-right-informations input {
    border: 1px solid #DADADA;
    border-radius: 4px 0 0 4px;
    height: 2.5rem;
    width: 100%;
    padding: 0 1em;
  }

  .box-right-informations span{
    display: inline-flex;
    align-items: center;
    width: 50%;
    margin-right: 0.5rem;
  }
  .box-right-informations .copy-button {
    background-color: var(--primary-color);
    border-radius: 0 4px 4px 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: .3rem;
    padding: 0 .5rem;
    cursor: pointer;
  }
  .box-right-informations .copy-button img {
    width: 16px;
  }
  .box-right-informations .copy-button span {
    color: white;
  }
  .svg-success{
    color: white;
    animation-name: svgSuccess;
    animation-duration: 1s;
  }
  @keyframes svgSuccess {
    from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}
  }
  .box-first-informations{
    display: flex;
    gap: 1em;
    align-items: center;
    flex-wrap: wrap;
  }
  .button-informations{
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    background: transparent;
    border-radius: 4px;
    transition: .4s;
  }
  .button-blue{
    border: 1px solid #097EF6;
    color: #097ef6;
  }
  .button-blue:hover{
    background-color: #097EF6;
    color: #fff;
  }
  .button-gray{
    border: 1px solid #ACACAC;
    color: #ACACAC;
  }
  .button-gray:hover{
    background-color: #ACACAC;
    color: #fff;
  }
  .button-red{
    border: 1px solid #FD6020;
    color: #FD6020;
  }
  .button-red:hover{
    background-color: #FD6020;
    color: #fff;
  }
  .invoice-payment-badge{
    border: 1px solid #D9D9D9;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .invoice-payment-badge:first-child{
    padding: 3px;
  }
  .button-close{
    position: absolute;
    top: 15px;
    right: 20px;
  }
  .button-close span{
    font-size: 1.2em;
  }
  .modal-content{
    border-radius: 12px;
    padding: 1.2em;
  }
  .modal-body{
    padding: 20px 30px 20px 30px;
  }
  .alert-infos{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1em;
    margin-bottom: 1em;
  }
  .box-labels{
    display: flex;
    align-content: center;
    justify-content:space-between;
    padding: 5px 1px;
  }
  .box-labels .label-field{
    font-weight: 400;
    font-size: 14px;
    color: #097EF6;
  }
  .box-labels .span-required{
    color: #ACACAC;
    font-weight: 100;
    font-size: 14px;
  }
  .modal-title{
    font-size: 1.5em;
    display: flex;
    justify-content: center;
    color: #0053C2;
    font-weight: 100;
    text-transform: capitalize
  }
  .modal-footer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px 20px 30px;
  }
  .has-erros{
    border: 1px solid #ed5565;
  }
  .fa-2x {
    font-size: 1em;
  }
  .button-print,
  .button-cancel{
    border-radius: 4px;
    padding: 1em;
    width: 100%;
    color: #fff;
    font-weight: bold;
    font-size: 1em;
  }
  .button-print{
    background-color: #097EF6;
    border-color: #097EF6;
  }
  .button-cancel{
    background-color: #ed5565;
    border-color: #ed5565;
  }
  .button-print:hover{
    background-color: #1c8af8;
  }
  .box-person-form{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 3rem;
  }
  .button-form{
    display: flex !important;
    justify-content: end !important;
    margin-left: auto;
    transition: 1s;
  }
  .button-form button{
    background-color: #006CFF;
    color: #fff;
    padding: 1rem 5rem;
    border-radius: 4px;
    border: none;
    outline: none;
    display: flex;
    justify-content: center;
    transition: .5s;
  }
  .button-form button:hover{
    background-color: #006FE6;
  }
  .person-form{
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 1em 3em 3em;
    gap: 1.5rem;
    margin-bottom: 1rem;
  }
  .person-form div{
    display: flex;
    flex-direction: column;
  }
  .person-form div label{
    color: var(--primary-color) !important;
    font-weight: normal;
    margin-bottom: 0.7rem;
  }
  .person-form div .error{
    border: 1px solid #FF003C;
  }
  .person-form div input{
    background: #ffffff;
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    min-height: 42px;
    padding: 0.7rem;
    outline: none;
    transition: .5s;
    min-width: 250px;
    width: 25vw;
  }
  .person-form div input:focus{
    border: 1px solid #006CFF;
  }
  .person-content{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .person-content h3{
    padding-left: 1.8em;
  }
  .two-inputs{
    display: flex !important;
    flex-direction: row !important;
    gap: 1em !important;
    width: 25vw !important;
    min-width: 250px !important;
  }
  .two-inputs div input{
    min-width: 0 !important;
  }
  .w-80{
    width: 80% !important;
  }
  .w-80 input{
    width: 100% !important;
  }
  .w-20{
    width: 20% !important;
  }
  .w-20 input{
    width: 100% !important;
  }
  .error-text{
    font-size: 14px;
    color: #FF003C;
    margin-top: 0.4rem;
  }

  .readonly {
    border: 1px solid #C4C4C4 !important;
    background-color: #eee !important;
    cursor: not-allowed;
    opacity: 1;
  }

  @keyframes openaccordion {
    from {margin-top: -3em; opacity: 0;}
    to {margin-top: 0; opacity: 1;}
  }
  @keyframes rotate180deg {
    from {transform: rotate(0deg);}
    to {transform: rotate(180deg);}
  }
  @keyframes rotate0deg {
    from {transform: rotate(180deg);}
    to {transform: rotate(0deg);}
  }
  @media screen and (max-width: 1250px) {
    .table-informations thead{
      display: none;
    }
    .table-informations td{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 1em;
    }
  }
  @media screen and (max-width: 970px) {
    .invoice-info{
      display: none;
    }
    .button-form{
      justify-content: center !important;
    }
  }
  @media screen and (max-width: 720px) {
    .first-informations{
      flex-direction: column;
    }
    .box-right-informations{
        width: 70%;
    }
  }
  @media screen and (max-width: 425px) {
    .box-right-informations{
        width: 90%;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/InvoicesNew.vue